import React from 'react';
import {useTranslation} from 'react-i18next';

import getIconByType from '../../../getIconByType';
import getTitleByType from '../../../getTitleByType';
import {getDateByCustomFormat, DATE_FORMATS} from 'utils/date';
import {Layout, Text, WarningIcon} from '@phonectas/unifon-ui-kit';
import EventDescription from '../EventDescription';
import {EventData} from './types';

const ThreeSixtyNewSaf: React.FC<EventData> = ({data}) => {
	const [t] = useTranslation();
	const isWarning = data?.is_warning;
	const isSatisfactionFrom = data?.data_fields?.satisfaction_rating_from?.satisfaction_rating;
	const isSatisfactionTo = data?.data_fields?.satisfaction_rating_to?.satisfaction_rating;

	return (
		<Layout gap="sm" fullWidth nowrap fullHeight>
			<Layout direction="column" nowrap gap="md" alignItems="center" style={{width: '42px'}}>
				<Layout>
					{getIconByType(data?.feed_type)}
				</Layout>
				<Layout>
					{
						isWarning && (
							<Layout>
								<WarningIcon color="warning" />
							</Layout>
						)
					}
				</Layout>
			</Layout>
			<Layout direction="column" fullWidth nowrap>
				<Layout direction="row"gap="sm" fullWidth nowrap>
					<Layout direction="column" fullWidth nowrap gap="xs">
						<Layout direction="row" gap="xs" fullWidth alignItems="center" justifyContent="space-between">
							<Text variant="h3">{getTitleByType(data?.feed_type)}</Text>
							<Text color="textSecondary" variant="body1">
								{
									getDateByCustomFormat(data?.created_at, DATE_FORMATS.DD_MM_YY_HH_mm)
								}
							</Text>
						</Layout>
						<Layout fullWidth direction="row" nowrap>
							<Layout fullWidth gap="none">
								<Layout
									direction="row"
									justifyContent="space-between"
									fullWidth
									alignItems="center"
									gap="none"
								>
									<Text color="textSecondary" style={{alignItems: 'center'}} variant="body1">
										{data?.data_fields?.actor?.name}
									</Text>
								</Layout>
							</Layout>
						</Layout>
						<Layout direction="row" nowrap>
							<EventDescription
								description={
									isSatisfactionFrom && isSatisfactionTo ? (
										t('Changed from {{from}} to {{to}}', {
											from: isSatisfactionFrom,
											to: isSatisfactionTo,
										})

									) : (
										t('Changed to {{to}}', {
											to: isSatisfactionTo,
										})
									)
								}
							/>
						</Layout>
						<Layout direction="row" fullWidth style={{gap: '8px'}}>
						</Layout>
					</Layout>
				</Layout>
			</Layout>
		</Layout>
	);
}

export default ThreeSixtyNewSaf;
